const IMG_PROXY_HOST = process.env.REACT_APP_IMG_PROXY_URL;

const ALLOWED_URLS = process.env.REACT_APP_IMG_PROXY_ALLOWED_URLS.split(',');

export enum ImgProxySize {
  SMALL_AVATAR_SQUARED = '32:32',
  SMALL = '120:90',
  MEDIUM_AVATAR_SQUARED = '56:56',
  MEDIUM = '800:600',
  LARGE_AVATAR_SQUARED = '96:96',
}

export class ImgProxyResizer {
  private url: string;

  private isUrlAllowed() {
    // Check if the URL starts with any of the allowed prefixes
    for (const prefix of ALLOWED_URLS) {
      if (this.url?.startsWith(prefix)) {
        return true;
      }
    }

    return false;
  }

  constructor(url: string) {
    this.url = url;
  }

  public get smallAvatarSquaredUrl() {
    if (!this.url) {
      return '';
    }

    if (!this.isUrlAllowed()) {
      return this.url;
    }

    return `${IMG_PROXY_HOST}/unsafe/rs:fill:${ImgProxySize.SMALL_AVATAR_SQUARED}:1/format:webp/plain/${this.url}`;
  }

  public get mediumAvatarSquaredUrl() {
    if (!this.url) {
      return '';
    }

    if (!this.isUrlAllowed()) {
      return this.url;
    }

    return `${IMG_PROXY_HOST}/unsafe/rs:fill:${ImgProxySize.MEDIUM_AVATAR_SQUARED}:1/format:webp/plain/${this.url}`;
  }

  // Usually using this one for user avatars because it's the one that looks better
  // We add some size but we keep the avatar looking good even if we zoom in.
  public get largeAvatarSquaredUrl() {
    if (!this.url) {
      return '';
    }

    if (!this.isUrlAllowed()) {
      return this.url;
    }

    return `${IMG_PROXY_HOST}/unsafe/rs:fill:${ImgProxySize.LARGE_AVATAR_SQUARED}:1/format:webp/plain/${this.url}`;
  }

  public get smallUrl() {
    if (!this.url) {
      return '';
    }

    if (!this.isUrlAllowed()) {
      return this.url;
    }

    return `${IMG_PROXY_HOST}/unsafe/rs:fill:${ImgProxySize.SMALL}:1/format:webp/plain/${this.url}`;
  }

  public get mediumUrl() {
    if (!this.url) {
      return '';
    }

    if (!this.isUrlAllowed()) {
      return this.url;
    }

    return `${IMG_PROXY_HOST}/unsafe/rs:fill:${ImgProxySize.MEDIUM}:1/format:webp/plain/${this.url}`;
  }

  public get originalUrl() {
    return this.url;
  }
}
